import { connect } from "react-redux";
import {
  Box,
  Table,
  Text,
} from "@chakra-ui/react";
import WaitingTimeLineGraph from "../charts/WaitingTimeLineGraph";
import { formatTime, formatNumber } from "../../../store/helpers";
import ConfiguredReportTable from "../../reports/ConfiguredReportTable";
import { WAITING_TIME_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const renderWaitingSummaryCell = (row, columnId) => {
  if (columnId === "scopeName") return row.scopeName || row.name;
  if (columnId === "total") return formatNumber(row.totalTickets);
  if (columnId === "totalWaitingTime") return formatTime(row.totalWaitingTime);
  if (columnId === "average") return formatTime(row.avgWaitingTimePerTicket);
  if (columnId === "averagePerDay") return formatTime(row.avgWaitingTimePerDay);
  if (columnId === "min") return formatTime(row.minWaitingTimePerDay);
  if (columnId === "max") return formatTime(row.maxWaitingTimePerDay);
  return null;
};

const WaitingTimeTable = ({ table, chart, reportIndex, renderConfig }) => {
  if (!renderConfig?.charts?.enabled) {
    return (
      <Box mt={10} className="waitingSummaryBlock">
        <ConfiguredReportTable
          columns={WAITING_TIME_SUMMARY_COLUMN_DEFINITIONS}
          rows={table.map((row) => ({ ...row, scopeName: row.name || "Entire Organization" }))}
          renderConfig={renderConfig}
          renderCell={renderWaitingSummaryCell}
        />
      </Box>
    );
  }

  return (
    <Box mt={10}>
      <Box>
        {table.map((a, index) => (
          <Box className="reportContainer" key={index}>
            <Box mb="10px">
              <h3>
                {reportIndex}. {index + 1}. {a.name}
              </h3>
            </Box>
            <Table.Root key={index} className="stripedTable" size="sm">
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Total Tickets</Table.ColumnHeader>
                  <Table.ColumnHeader borderRight="1px solid #dadce0">Total Waiting Time</Table.ColumnHeader>
                  <Table.ColumnHeader>Avg /ticket</Table.ColumnHeader>
                  <Table.ColumnHeader>Avg /day</Table.ColumnHeader>
                  <Table.ColumnHeader>Min.</Table.ColumnHeader>
                  <Table.ColumnHeader>Max</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text color={"var(--blue)"}>{formatNumber(a.totalTickets)}</Text>
                  </Table.Cell>
                  <Table.Cell borderRight="1px solid #dadce0">
                    <Text color={"var(--blue)"}>{formatTime(a.totalWaitingTime)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatTime(a.avgWaitingTimePerTicket)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatTime(a.avgWaitingTimePerDay)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatTime(a.minWaitingTimePerDay)}</Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text>{formatTime(a.maxWaitingTimePerDay)}</Text>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table.Root>
            <Box className="singleSeriesChartBlock">
              <WaitingTimeLineGraph
                title={`Entire Organization: Day by Day Comparison`}
                chart={chart}
                chartHeight="300px"
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  const { defaultReducer } = state;
  return {
    tickets: defaultReducer.tickets,
  };
};

export default connect(mapStateToProps, {})(WaitingTimeTable);
